module.exports = __webpack_public_path__ + "static/media/index.a551d5c9.less";